<script>
import { jsPDF } from "jspdf";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { fontAssets } from "@/utils/fontRegistry";
import { generateWordProposal } from "@/utils/wordGenerator/index.js";
import { saveAs } from 'file-saver';
import FPTemp1 from "@/components/templates/frontPages/FPTemp1.vue";
import FPTemp2 from "@/components/templates/frontPages/FPTemp2.vue";
import FPTemp3 from "@/components/templates/frontPages/FPTemp3.vue";
import CPTemp1 from "@/components/templates/comparableProject/CPTemp1.vue";
import CPTemp2 from "@/components/templates/comparableProject/CPTemp2.vue";
import CPTemp3 from "@/components/templates/comparableProject/CPTemp3.vue";
import ResumeTemp1 from "@/components/templates/resume/ResumeTemp1.vue";
import ResumeTemp2 from "@/components/templates/resume/ResumeTemp2.vue";
import ApprTemp1 from "@/components/templates/approach/ApprTemp1.vue";
import ApprTemp2 from "@/components/templates/approach/ApprTemp2.vue";
import ApprTemp3 from "@/components/templates/approach/ApprTemp3.vue";
import ApprTemp4 from "@/components/templates/approach/ApprTemp4.vue";
import ApprTemp5 from "@/components/templates/approach/ApprTemp5.vue";
import ApprTemp6 from "@/components/templates/approach/ApprTemp6.vue";
import LPTemp1 from "@/components/templates/lastPages/LPTemp1.vue";
import LPTemp2 from "@/components/templates/lastPages/LPTemp2.vue";
import LPTemp3 from "@/components/templates/lastPages/LPTemp3.vue";
import TOCTemp1 from "@/components/templates/TableOfContent/TOCTemp1.vue";
import TOCTemp2 from "@/components/templates/TableOfContent/TOCTemp2.vue";
import TOCTemp3 from "@/components/templates/TableOfContent/TOCTemp3.vue";
import TOCTemp4 from "@/components/templates/TableOfContent/TOCTemp4.vue";
import TOCTemp5 from "@/components/templates/TableOfContent/TOCTemp5.vue";
import TOCTemp6 from "@/components/templates/TableOfContent/TOCTemp6.vue";
import TOCTemp7 from "@/components/templates/TableOfContent/TOCTemp7.vue";
import OrgChartTemp1 from "@/components/templates/orgChart/OrgChartTemp1.vue";
import OrgChartTemp2 from "@/components/templates/orgChart/OrgChartTemp2.vue";
import SelectDropdown from "@/components/SelectDropdown.vue";
import OrgChartTemp3 from "@/components/templates/orgChart/OrgChartTemp3.vue";
import OrgChartTemp4 from "@/components/templates/orgChart/OrgChartTemp4.vue";
import OrgChartTemp5 from "@/components/templates/orgChart/OrgChartTemp5.vue";
import OrgChartTemp6 from "@/components/templates/orgChart/OrgChartTemp6.vue";
import OrgChartTemp7 from "@/components/templates/orgChart/OrgChartTemp7.vue";
import ResumeTemp3 from "@/components/templates/resume/ResumeTemp3.vue";
import ResumeTemp4 from "@/components/templates/resume/ResumeTemp4.vue";
import ResumeTemp5 from "@/components/templates/resume/ResumeTemp5.vue";
import ResumeTemp6 from "@/components/templates/resume/ResumeTemp6.vue";
import ResumeTemp7 from "@/components/templates/resume/ResumeTemp7.vue";
import FPTemp4 from "@/components/templates/frontPages/FPTemp4.vue";
import FPTemp5 from "@/components/templates/frontPages/FPTemp5.vue";
import FPTemp6 from "@/components/templates/frontPages/FPTemp6.vue";
import FPTemp7 from "@/components/templates/frontPages/FPTemp7.vue";
import LPTemp4 from "@/components/templates/lastPages/LPTemp4.vue";
import LPTemp5 from "@/components/templates/lastPages/LPTemp5.vue";
import LPTemp6 from "@/components/templates/lastPages/LPTemp6.vue";
import LPTemp7 from "@/components/templates/lastPages/LPTemp7.vue";
import CPTemp5 from "@/components/templates/comparableProject/CPTemp5.vue";
import CPTemp6 from "@/components/templates/comparableProject/CPTemp6.vue";
import CPTemp7 from "@/components/templates/comparableProject/CPTemp7.vue";
import CPTemp8 from "@/components/templates/comparableProject/CPTemp8.vue";
import CPTemp9 from "@/components/templates/comparableProject/CPTemp9.vue";
import CPTemp10 from "@/components/templates/comparableProject/CPTemp10.vue";
import CPTemp11 from "@/components/templates/comparableProject/CPTemp11.vue";
import CPTemp12 from "@/components/templates/comparableProject/CPTemp12.vue";
import CPTemp13 from "@/components/templates/comparableProject/CPTemp13.vue";
import CPTemp14 from "@/components/templates/comparableProject/CPTemp14.vue";
import CPTemp15 from "@/components/templates/comparableProject/CPTemp15.vue";
import CPTemp16 from "@/components/templates/comparableProject/CPTemp16.vue";
import ExtraPages from "@/components/ExtraPages.vue";
import ManagePagesModal from "@/components/ManagePagesModal.vue";
import AppButton from "@/components/AppButton.vue";
import {
  isFrontPageReady,
  isTOCReady,
  isOrgChartReady,
  isResumeReady,
  isComparableReady,
  isApproachReady,
  isLastPageReady
} from "@/utils/proposalValidation";
import { loadingLgIcon } from "@/utils/proposalIcons";
import CPTemp4 from "@/components/templates/comparableProject/CPTemp4.vue";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import {
  fn_waitForImages,
  fn_htmlToPdfBuffer,
  fn_mergePdfBuffer,
  fn_computeExpectedPages,
  fn_resolveStartPage,
  fn_decodeBase64Pdf,
  fn_embedCustomPdfPage,
  fn_loadAllFonts,
  fn_elementToPdfBuffer,
  fn_normalizePdfBuffer,
  fn_binaryStringToArrayBuffer,
  fn_pdfPageCount
} from "@/utils/pdfUtils";

export default {
  name: "CompleteProposal",
  components: {
    FPTemp1, FPTemp2, FPTemp3, FPTemp4, FPTemp5, FPTemp6, FPTemp7,
    CPTemp1, CPTemp2, CPTemp3, CPTemp4, CPTemp5, CPTemp6, CPTemp7, CPTemp8, CPTemp9, CPTemp10, CPTemp11, CPTemp12, CPTemp13, CPTemp14, CPTemp15, CPTemp16,
    ResumeTemp1, ResumeTemp2, ResumeTemp3, ResumeTemp4, ResumeTemp5, ResumeTemp6, ResumeTemp7,
    ApprTemp1, ApprTemp2, ApprTemp3, ApprTemp4, ApprTemp5, ApprTemp6,
    LPTemp1, LPTemp2, LPTemp3, LPTemp4, LPTemp5, LPTemp6, LPTemp7,
    TOCTemp1, TOCTemp2, TOCTemp3, TOCTemp4, TOCTemp5, TOCTemp6, TOCTemp7,
    OrgChartTemp1, OrgChartTemp2, OrgChartTemp3, OrgChartTemp4, OrgChartTemp5, OrgChartTemp6, OrgChartTemp7,
    SelectDropdown,
    ExtraPages,
    ManagePagesModal,
    AppButton,
  },
  props: {
    proposal: { type: Object, required: true },
    pageStartMap: { type: Object, default: () => ({}) },
	steps: { type: Object, required: true },
  },
  data() {
    return {
      selectedExport: "",
      isGeneratingPDF: false,
      showCanvaModal: false,
      showManageModal: false,
      loadingLgIcon,
	  allSections:[
          { key: 'frontPage', class: 'kb-section-frontPage' },
          { key: 'toc', class: 'kb-section-toc' },
          { key: 'orgChart', class: 'kb-section-orgChart' },
          { key: 'resume', class: 'kb-section-resume' },
          { key: 'comparable', class: 'kb-section-comparable' },
          { key: 'approach', class: 'kb-section-approach' },
          { key: 'lastPage', class: 'kb-section-lastPage' },
        ],
    };
  },
  created (){
	    console.log('In CompleteProposal created steps proposal');
		console.log(this.steps);
		console.log(this.proposal);

  
  },
  async mounted() {
  		console.log("In mounted m_syncTOC");
		//await this.$nextTick();
		setTimeout(() => {
           this.m_syncTOC();
           }, 1000);
  },
  computed: {
    isCoverPageIncluded() {
      return this.$store.state.settings.includeCoverPage;
    },
    pageGap() {
      return !this.$store.state.loading.isExporting;
    },
    exportOptions() {
      return this.proposal && this.proposal.pageOrientation === "landscape" ? [
        { label: "Export to PDF", value: "pdf" },
        { label: "Export to Canva", value: "canva" },
      ] : [
        { label: "Export to Word", value: "word" },
        { label: "Export to PDF", value: "pdf" },
        { label: "Export to Canva", value: "canva" },
      ];
    },
    isFrontPagePreviewable() {
      return isFrontPageReady(this.proposal.frontPage);
    },
    isTOCPreviewable() {
      return isTOCReady(this.proposal.toc);
    },
    isOrgChartPreviewable() {
      return isOrgChartReady(this.proposal.orgChart);
    },
    isResumePreviewable() {
      return isResumeReady(this.proposal.resume);
    },
    isComparablePreviewable() {
      return isComparableReady(this.proposal.comparable);
    },
    isApproachPreviewable() {
      return isApproachReady(this.proposal.approach);
    },
    isLastPagePreviewable() {
      return isLastPageReady(this.proposal.lastPage);
    },
    hasFPExtras() {
      return this.proposal.customPages && this.proposal.customPages.some(f => f.position === 'frontPage');
    },
    visibleSections() {
      //const order = this.proposal.sectionOrder || ['orgChart', 'resume', 'comparable', 'approach'];
      //return order.filter(key => this.isSectionVisible(key));
	  return this.proposal.sectionOrder.filter(key => this.isSectionVisible(key));
    },
    noContentAvailable() {
      return this.visibleSections.length === 0 &&
        !this.isFrontPagePreviewable &&
        !this.isTOCPreviewable &&
        !this.isLastPagePreviewable &&
        !this.hasFPExtras;
    },
    sectionsReadiness() {
      return {
        frontPage: this.isFrontPagePreviewable,
        toc: this.isTOCPreviewable,
        orgChart: this.isOrgChartPreviewable,
        resume: this.isResumePreviewable,
        comparable: this.isComparablePreviewable,
        approach: this.isApproachPreviewable,
        lastPage: this.isLastPagePreviewable
      };
    }
  },
  watch: {
  'proposal': {
    deep: true,
    immediate: false,
    handler() {
      this.$nextTick(() => this.m_syncTOC());
    }
  }
},
  methods: {
    getComparableBlockStartPage(targetIdx) {
      let start = (this.pageStartMap && this.pageStartMap.comparable) || 1;
      const blocks = this.proposal.comparable.blocks || [this.proposal.comparable];

      for (let i = 0; i < targetIdx; i++) {
        const block = blocks[i];
        const t = block.template;
        const count = block.projects ? block.projects.length : 0;
        let blockPages = 0;
        if (t === 1 || t === 4 || t === 6 || t === 7) blockPages = Math.ceil(count / 2);
        else if (t === 3 || t === 14) blockPages = Math.ceil(count / 4);
        else if (t === 8 || t === 15) blockPages = 1;
        else blockPages = count;

        start += blockPages;
      }
      return start;
    },
    getResumeBlockStartPage(targetIdx) {
      let start = (this.pageStartMap && this.pageStartMap.resume) || 1;
      const blocks = this.proposal.resume.blocks || [this.proposal.resume];

      for (let i = 0; i < targetIdx; i++) {
        const block = blocks[i];
        const t = block.template;
        const memberCount = block.members ? block.members.length : 0;
        let blockPages = 0;
        if (t === 3 || t === 4 || t === 6) blockPages = Math.ceil(memberCount / 2);
        else blockPages = memberCount;

        start += blockPages;
      }
      return start;
    },
    handleEdit() {
      this.$emit("edit");
    },
    openManageModal() {
      this.showManageModal = true;
    },
    handleUpdateProposal(updatedData) {
      this.$emit("updateProposal", updatedData);
    },
    async handleExport(value) {
      if (value === "pdf") {
        await this.exportToPDF();
      } else if (value === "canva") {
        this.showCanvaModal = true;
      } else if (value === "word") {
        await this.exportToWord();
      } else {
        this.selectedExport = value;
        alert(`Exporting to ${value}...`);
      }
    },
    async handleCanvaExport() {
      this.showCanvaModal = false;
      await this.exportToPDF
      window.open('https://www.canva.com/', '_blank');
    },
    async waitForImages(element) {
      const images = Array.from(element.querySelectorAll("img"));
      images.forEach(img => {
        if (img.getAttribute("loading") === "lazy") {
          img.removeAttribute("loading");
        }
      });

      const promises = images.map((img) => {
        if (img.complete) {
          if (img.decode) {
            return img.decode().catch((err) => {
              console.error("Failed to decode image:", img.src, err);
            });
          }
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          img.onload = () => {
            if (img.decode) {
              img.decode().then(resolve).catch((err) => {
                console.error("Failed to decode image on load:", img.src, err);
                resolve();
              });
            } else {
              resolve();
            }
          };
          img.onerror = () => {
            console.error("Failed to load image:", img.src);
            resolve();
          };
        });
      });
      await Promise.all(promises);
    },
    async exportToWord() {
      this.isGeneratingPDF = true;
      this.$store.commit("SET_LOADING", { isExporting: true });
      try {
        const docBlob = await generateWordProposal(this.proposal, this.pageStartMap);
        saveAs(docBlob, `Proposal_document.docx`);
      } catch (error) {
        console.error("Word export failed:", error);
        alert("Failed to generate Word document.");
      } finally {
        this.$store.commit("SET_LOADING", { isExporting: false });
        this.isGeneratingPDF = false;
        this.selectedExport = "";
      }
    },
    isSectionVisible(key) {
      if (key === 'orgChart') return this.isOrgChartPreviewable;
      if (key === 'resume') return this.isResumePreviewable;
      if (key === 'comparable') return this.isComparablePreviewable;
      if (key === 'approach') return this.isApproachPreviewable;
      return false;
    },
    hexToPdfRgb(hex) {
      if (!hex) return rgb(0.33, 0.33, 0.33);
      const cleanHex = hex.replace('#', '');
      let r = 0, g = 0, b = 0;
      if (cleanHex.length === 3) {
        r = parseInt(cleanHex[0] + cleanHex[0], 16) / 255;
        g = parseInt(cleanHex[1] + cleanHex[1], 16) / 255;
        b = parseInt(cleanHex[2] + cleanHex[2], 16) / 255;
      } else if (cleanHex.length === 6) {
        r = parseInt(cleanHex.substring(0, 2), 16) / 255;
        g = parseInt(cleanHex.substring(2, 4), 16) / 255;
        b = parseInt(cleanHex.substring(4, 6), 16) / 255;
      }
      return rgb(r, g, b);
    },
async m_syncTOC() {
  

  try {
    
    const newPages = [];
    const customPages = this.proposal.customPages || [];
	const isLandscape = this.proposal.pageOrientation === 'landscape';

    const sectionMap = {
      orgChart: {
        id: "orgChart",
		class:"kb-section-orgChart",
        name: this.proposal.orgChart.title,
        check: () => isOrgChartReady(this.proposal.orgChart)
      },
      resume: {
        id: "resume",
		class:"kb-section-resume",
        name: this.proposal.resume.title,
        check: () => isResumeReady(this.proposal.resume)
      },
      comparable: {
        id: "comparable",
		class:"kb-section-comparable",
        name: this.proposal.comparable.title,
        check: () => isComparableReady(this.proposal.comparable)
      },
      approach: {
        id: "approach",
		class:"kb-section-approach",
        name: this.proposal.approach.title,
        check: () => isApproachReady(this.proposal.approach)
      }
    };

    let totalPages = 0;
	let pageCount=0;

    const nonPagedSteps=["frontPage","toc","lastPage"];
	const pageSteps=this.steps.filter(s=>!nonPagedSteps.includes(s.key));
	
 for (const s of pageSteps) {
  let page = null;
  let pageCount = 1;

  if (s.type === "uploadedPdf") {
    const cp = customPages.find(p => p.id == s.key);
    const el = this.$refs.proposalContainer.querySelector(`.${s.class}`);

    // Generate PDF and count pages
    const resp = await fn_htmlToPdfBuffer(el, { isLandscape });
    pageCount = resp?.pageCount || 1;

    page = {
      id: `custom_${s.key}`,
      name: s.title || "Extra Page",
      heading: s.title || "Extra Page",
      page: totalPages + 1,
      pageCount,
      sectionId: `custom_${s.key}`
    };

  } else {
    const section = sectionMap[s.key];
    const el = this.$refs.proposalContainer.querySelector(`.${s.class || section.class}`);

    console.log("Section element:", el);
    console.log("DOM height:", el.getBoundingClientRect().height);

    // Actual PDF page count
    //const resp = await fn_htmlToPdfBuffer(el, { isLandscape });
    //pageCount = resp.pageCount || 1;
	pageCount = fn_pdfPageCount(el);
    

    page = {
      id: section?.id || s.key,
      name: section?.name || s.title,
      heading: section?.name || s.title,
      page: totalPages + 1,
      pageCount,
      sectionId: section?.id || s.key
    };
  }

  totalPages += pageCount;
  newPages.push(page);
  
}
    console.log("newPages", newPages);

    // Prevent infinite loops
    const oldPages = this.proposal.toc.pages || [];
    if (JSON.stringify(oldPages) === JSON.stringify(newPages)) {
      return;
    }

    this.proposal.toc.pages = [...newPages];

  } finally {}
},
async exportToPDF() {
  try {
    this.$store.commit("SET_LOADING", { isExporting: true });
	const isLandscape = this.proposal.pageOrientation === 'landscape';
    this.isGeneratingPDF = true;

    await fn_waitForImages(this.$refs.proposalContainer);

    const loadedFonts = await fn_loadAllFonts(fontAssets);
    const finalDoc = await PDFDocument.create();
    const helveticaFont = await finalDoc.embedFont(StandardFonts.HelveticaBold);

    

    for (const section of this.steps) {

      if (section.type === "uploadedPdf") {
		const fileName = this.proposal.customPages.find(p => p.id == section.key)?.fileName;
		if(fileName){
			 const el = document.getElementById(section.key);
			 const resp = await fn_htmlToPdfBuffer(el, { isLandscape });
			 await fn_mergePdfBuffer(finalDoc, resp.buffer, resp?.pageCount);
			 
		}

  } else {

    const blockedSections=["comparable","resume","approach"];
    const el = this.$refs.proposalContainer.querySelector(`.${section.class}`);
    if (!el) continue;
	if(blockedSections.includes(section.key) && !this.proposal[section.key].blocks[0].template) continue;
    const resp = await fn_htmlToPdfBuffer(el, isLandscape);
	await fn_mergePdfBuffer(finalDoc, resp.buffer, resp?.pageCount);
    }
  }

    //await this.m_addPageNumbers(finalDoc);
    const bytes = await finalDoc.save();
    window.open(URL.createObjectURL(new Blob([bytes], { type: "application/pdf" })));

  } catch (err) {
    console.error("PDF generation failed:", err);
  } finally {
    this.$store.commit("SET_LOADING", { isExporting: false });
    this.isGeneratingPDF = false;
  }
},
async m_addPdfPageNumbers(finalDoc) {
  const font = await finalDoc.embedFont(StandardFonts.Helvetica);
  const pageCount = finalDoc.getPageCount();

  for (let i = 0; i < pageCount; i++) {
    const page = finalDoc.getPage(i);
    const { width, height } = page.getSize();

	if(![0,1,pageCount-1].includes(i)) {
         page.drawText(`Page ${i - 1} of ${pageCount-3}`, {
            x: width / 2 - 30,
            y: 20,
            size: 10,
            font,
            color: rgb(0.2, 0.2, 0.2),
		});
	  }
    }
  },
 m_getStartPage(sectionId){ return this.proposal.toc.pages.filter(p=>p.id == sectionId)[0]?.page||1;},
 
}

};
</script>

<template>
  <div>
    <div v-if="isGeneratingPDF" class="loading-overlay">
      <div class="spinner-container">
        <span class="export-spinner" v-html="loadingLgIcon" />
        <p>Generating Pdf...</p>
      </div>
    </div>
    <div class="sticky-proposal-header d-flex flex-column flex-sm-row justify-content-between align-items-sm-start border-bottom p-2 mb-3 gap-5">
      <div class="d-flex flex-column">
        <div class="d-flex gap-5 mt-2">
		  <b-button class="btn-back" title="Back" variant="outline-primary" @click="handleEdit">
				<fa-icon icon="arrow-left" />
          </b-button>
        </div>
      </div>
	  <b-dropdown variant="none" style="border:none;width:200px;" no-caret  menu-class="export-menu" toggle-class="export-trigger" right>
			<template v-slot:button-content>
				<fa-icon icon="file-export" class="export-icon" />
				<span>Export</span>
			</template>

			<div class="export-menu">
				<b-button class="export-item" variant="link" @click="handleExport('pdf')">
					<fa-icon icon="file-pdf" class="export-icon-item pdf" />
					<span>Export to PDF</span>
				</b-button>

				<b-button class="export-item" variant="link" @click="handleExport('word')">
					<fa-icon icon="file-word" class="export-icon-item word" />
					<span>Export to Word</span>
				</b-button>

				<b-button class="export-item" variant="link" @click="handleExport('canva')">
					<img src="@/assets/canva.png" class="export-icon-item canva" />
					<span>Export to Canva</span>
				</b-button>
			</div>
			
	 </b-dropdown>
    </div>
    <div id="preview-container" class="preview-container">
      <div ref="proposalContainer" class="proposal-content" :class="{ 'page-gap': pageGap }">

        <div v-if="noContentAvailable" class="text-center py-5">
          <p class="text-muted">No content available to preview. Please complete the proposal sections.</p>
        </div>
		
			  
		
	    <div v-for="(section, index) in steps" :key="section.key"
          class="w-100 d-flex flex-column align-items-center" :class="{ 'page-gap': pageGap }" >

        <!-- Front Page -->
        <div id="frontPage" v-if="section.key=='frontPage'&& isFrontPagePreviewable" class="kb-section-frontPage">
          <FPTemp1 v-if="proposal.frontPage.template === 1" :proposal="proposal.frontPage" />
          <FPTemp2 v-if="proposal.frontPage.template === 2" :proposal="proposal.frontPage" />
          <FPTemp3 v-if="proposal.frontPage.template === 3" :proposal="proposal.frontPage" />
          <FPTemp4 v-if="proposal.frontPage.template === 4" :proposal="proposal.frontPage" />
          <FPTemp5 v-if="proposal.frontPage.template === 5" :proposal="proposal.frontPage" />
          <FPTemp6 v-if="proposal.frontPage.template === 6" :proposal="proposal.frontPage" />
          <FPTemp7 v-if="proposal.frontPage.template === 7" :proposal="proposal.frontPage" />

        </div>

        <!-- Table of Contents -->
		<div id="toc">
          <div  v-if="section.key=='toc'&&isTOCPreviewable" class="kb-section-toc text-left" @click="m_syncTOC">
            <TOCTemp1 v-if="proposal.toc.template === 1" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp2 v-if="proposal.toc.template === 2" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp3 v-if="proposal.toc.template === 3" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp4 v-if="proposal.toc.template === 4" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp5 v-if="proposal.toc.template === 5" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp6 v-if="proposal.toc.template === 6" :toc="proposal.toc" :pageGap="pageGap" />
            <TOCTemp7 v-if="proposal.toc.template === 7" :toc="proposal.toc" :pageGap="pageGap" />
          </div>

          <ExtraPages v-if="isFrontPagePreviewable || isTOCPreviewable || hasFPExtras"
            :orientation="proposal.pageOrientation" :uploadedFiles="proposal.customPages || []" :position="'frontPage'"
            :pageGap="pageGap" :startPage="pageStartMap && pageStartMap.frontPageExtra" :colorScheme="proposal.style && proposal.style.colorScheme" />
        </div>
        
        
		  
		  <!-- Extra Pages-->
		  <ExtraPages
               v-if="section.type === 'uploadedPdf'"
			   :id="`extra-pages-${section.key}`"
			   :class="`extra-pages-${section.key}`"
               :orientation="proposal.pageOrientation"
               :fileId="section.key"
               :colorScheme="proposal.style && proposal.style.colorScheme"
			   :uploadedFiles="proposal.customPages" 
			   :startPage="m_getStartPage(`custom_${section.key}`)"
             />

          <!-- Project Org Chart -->
          <template id="orgChart" v-if="section.key === 'orgChart'">
            <div class="kb-section-orgChart">
              <OrgChartTemp1 v-if="proposal.orgChart.template === 1" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp2 v-if="proposal.orgChart.template === 2" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp3 v-if="proposal.orgChart.template === 3" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp4 v-if="proposal.orgChart.template === 4" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp5 v-if="proposal.orgChart.template === 5" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp6 v-if="proposal.orgChart.template === 6" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
              <OrgChartTemp7 v-if="proposal.orgChart.template === 7" :orgChart="proposal.orgChart"
                :startPage="m_getStartPage('orgChart')" />
            </div>

            <ExtraPages :orientation="proposal.pageOrientation" :uploadedFiles="proposal.customPages || []"
              :position="'orgChart'" :pageGap="pageGap" :startPage="pageStartMap && pageStartMap.orgChartExtra"
              :colorScheme="proposal.style && proposal.style.colorScheme" />
          </template>

          <!-- Resume -->
          <template id="resume" v-if="section.key === 'resume'">
            <div class="kb-section-resume text-left" :class="{ 'page-gap': pageGap }">
              <div v-for="(block, bIdx) in (proposal.resume.blocks || [proposal.resume])" :key="block.id || bIdx"
                class="resume-block-wrapper">
                <ResumeTemp1 v-if="block.template === 1" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp2 v-if="block.template === 2" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp3 v-if="block.template === 3" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp4 v-if="block.template === 4" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp5 v-if="block.template === 5" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp6 v-if="block.template === 6" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
                <ResumeTemp7 v-if="block.template === 7" :resume="{ ...proposal.resume, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('resume')" />
              </div>
            </div>

            <ExtraPages :orientation="proposal.pageOrientation" :uploadedFiles="proposal.customPages || []"
              :position="'resume'" :pageGap="pageGap" :startPage="pageStartMap && pageStartMap.resumeExtra"
              :colorScheme="proposal.style && proposal.style.colorScheme" />
          </template>

          <template id="comparable" v-if="section.key === 'comparable'">
            <div class="kb-section-comparable  text-left" :class="{ 'page-gap': pageGap }">
              <div v-for="(block, bIdx) in (proposal.comparable.blocks || [proposal.comparable])"
                :key="block.id || bIdx" class="comparable-block-wrapper ">
                <CPTemp1 v-if="block.template === 1" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp2 v-if="block.template === 2" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp3 v-if="block.template === 3" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp4 v-if="block.template === 4" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp5 v-if="block.template === 5" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp6 v-if="block.template === 6" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp7 v-if="block.template === 7" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp8 v-if="block.template === 8" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp9 v-if="block.template === 9" :projects="{ ...proposal.comparable, ...block }" :pageGap="pageGap"
                  :startPage="m_getStartPage('comparable')" />
                <CPTemp10 v-if="block.template === 10" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp11 v-if="block.template === 11" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp12 v-if="block.template === 12" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp13 v-if="block.template === 13" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp14 v-if="block.template === 14" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp15 v-if="block.template === 15" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
                <CPTemp16 v-if="block.template === 16" :projects="{ ...proposal.comparable, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('comparable')" />
              </div>
            </div>

            <ExtraPages :orientation="proposal.pageOrientation" :uploadedFiles="proposal.customPages || []"
              :position="'comparable'" :pageGap="pageGap" :startPage="pageStartMap && pageStartMap.comparableExtra"
              :colorScheme="proposal.style && proposal.style.colorScheme" />
          </template>

          <!-- Approach -->
          <template id="approach"  v-if="section.key === 'approach'">
            <div class="kb-section-approach" :class="{ 'page-gap': pageGap }">
              <div v-for="(block, bIdx) in (proposal.approach.blocks || [proposal.approach])" :key="block.id || bIdx"
                class="approach-block-wrapper">
                <ApprTemp1 v-if="block.template === 1" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
                <ApprTemp2 v-if="block.template === 2" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
                <ApprTemp3 v-if="block.template === 3" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
                <ApprTemp4 v-if="block.template === 4" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
                <ApprTemp5 v-if="block.template === 5" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
                <ApprTemp6 v-if="block.template === 6" :questions="{ ...proposal.approach, ...block }"
                  :pageGap="pageGap" :startPage="m_getStartPage('approach')" />
              </div>
            </div>

            <ExtraPages :orientation="proposal.pageOrientation" :uploadedFiles="proposal.customPages || []"
              :position="'approach'" :pageGap="pageGap" :startPage="pageStartMap && pageStartMap.approachExtra"
              :colorScheme="proposal.style && proposal.style.colorScheme" />
          </template>
       

        <!-- Last Page -->
        <div id="lastPage" v-if="section.key==='lastPage' &&isLastPagePreviewable" class="kb-section-lastPage">
          <LPTemp1 v-if="proposal.lastPage.template === 1" :proposal="proposal.lastPage" />
          <LPTemp2 v-if="proposal.lastPage.template === 2" :proposal="proposal.lastPage" />
          <LPTemp3 v-if="proposal.lastPage.template === 3" :proposal="proposal.lastPage" />
          <LPTemp4 v-if="proposal.lastPage.template === 4" :proposal="proposal.lastPage" />
          <LPTemp5 v-if="proposal.lastPage.template === 5" :proposal="proposal.lastPage" />
          <LPTemp6 v-if="proposal.lastPage.template === 6" :proposal="proposal.lastPage" />
          <LPTemp7 v-if="proposal.lastPage.template === 7" :proposal="proposal.lastPage" />
        </div>
		
	    </div>
      </div>
    </div>
    <!-- Canva Export Modal -->
    <b-modal v-model="showCanvaModal" title="Export to Canva" centered hide-footer scrollable>
      <div>
        <p class="modal-intro">Follow these simple steps to edit your proposal in Canva:</p>

        <div class="instruction-steps">
          <div class="step">
            <span class="step-number">1</span>
            <div class="step-content">
              <strong>Download PDF</strong>
              <p>Your proposal will be exported as a PDF file</p>
            </div>
          </div>

          <div class="step">
            <span class="step-number">2</span>
            <div class="step-content">
              <strong>Open Canva</strong>
              <p>Go to <a href="https://www.canva.com" target="_blank">Canva.com</a> or click the button below</p>
            </div>
          </div>

          <div class="step">
            <span class="step-number">3</span>
            <div class="step-content">
              <strong>Import File</strong>
              <p>Click "Import file" or drag & drop your PDF into Canva</p>
            </div>
          </div>

          <div class="step">
            <span class="step-number">4</span>
            <div class="step-content">
              <strong>Edit Pages</strong>
              <p>Canva will automatically split your PDF into editable pages</p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <AppButton variant="primary" size="sm" @click="handleCanvaExport()">
            Download & Open Canva
          </AppButton>
        </div>
      </div>
    </b-modal>

    <!-- Unified Manage Pages Modal -->
    <ManagePagesModal :show="showManageModal" :proposal="proposal" :sectionsReadiness="sectionsReadiness"
      @close="showManageModal = false" @updateProposal="handleUpdateProposal" />
  </div>
</template>

<style scoped lang="scss">
.section-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: #333;
  margin-bottom: 0px;
}

.kb-section-comparable {
  display: flex;
  flex-direction: column;
}

.kb-section-resume {
  display: flex;
  flex-direction: column;
}

.kb-section-approach {
  display: flex;
  flex-direction: column;
}

.kb-section-resume.page-gap,
.kb-section-comparable.page-gap,
.kb-section-approach.page-gap {
  gap: 20px;
}


.section-subtitle {
  font-size: 12px;
  color: #666;
  margin-bottom: 0px;
}

.preview-container {
  padding: 15px;
  background: #f0f0f0;
}

.gap-5 {
  gap: 5px;
}

.proposal-content {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  overflow: visible;

  @media screen and (max-width: 1200px) {
    align-items: flex-start;
  }
}

.page-gap {
  gap: 20px;
}

.export-button {
  min-width: 115px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner-container {
  text-align: center;

  .export-spinner {
    display: inline-block;
    animation: spin 1s linear infinite;
    color: #4475b4;
  }

  p {
    padding-top: 10px;
    color: #4475b4;
    font-weight: bold;
  }
}

.instruction-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .step {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    .step-number {
      flex-shrink: 0;
      width: 36px;
      height: 36px;
      background: #5b9bd5;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
    }

    .step-content {
      flex: 1;

      strong {
        display: block;
        font-size: 14px;
        color: #333;
        margin-bottom: 4px;
      }

      p {
        margin: 0;
        font-size: 12px;
        color: #666;
        line-height: 1.5;
      }

      a {
        color: #5b9bd5;
        text-decoration: none;
        font-weight: 500;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.sticky-proposal-header {
  position: sticky;
  top: 10px;
  z-index: 100;
  background: white;
  margin: 0 -8px 20px -8px;
  padding: 15px 20px !important;
  border-radius: 0;
}


.btn-danger {
  border: none;
  font-size: 12px;
  padding: 5px 10px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.section-reorder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 211mm;
  padding: 8px 15px;
  background: #e0e0e0;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;

  .section-label {
    font-size: 14px;
    font-weight: 700;
    color: #444;
  }

  .layers-sec {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .layers-btn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f8f8f8;
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: pointer;
      color: #777;
      padding: 0;

      &:hover:not(:disabled) {
        background: #eee;
        color: #333;
        border-color: #999;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12px;
        height: 12px;
      }
    }
  }
}
.export-btn {
  height: 25px;
  display: flex;
  align-items: center;
  margin-right: 5px;
  border:none;
}
.export-icon {
  color: #4fa4ff !important;
}
.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dropdown-menu{
      background: white;
	  border: none !important;
      border-radius: 24px;
      padding1: 10px;
}
/* Make dropdown items look like links */
.dropdown-menu .dropdown-item {
  color: #4fa4ff !important;      /* Bootstrap link blue */
  background: transparent !important;
  text-decoration: none;
  padding: 6px 14px;
}


/* Hover: underline + subtle background */
.dropdown-menu .dropdown-item:hover {
  text-decoration: underline;
  background: rgba(0, 0, 0, 0.03) !important;
  color: #0056b3 !important;      /* darker blue on hover */
}
.canva-icon {
  width: 20px;
  height: 10px;
  vertical-align: middle;
  margin-right: 6px;
  border:none;
}
/* Remove default BootstrapVue dropdown styling */
.export-trigger + .dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}

/* Remove extra padding Bootstrap adds */
::v-deep .export-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  padding: 6px 0 !important;
  background: #fff !important;
  min-width: 200px;
}

::v-deep .export-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: left;
  padding: 6px 12px !important;
  color: #4fa4ff !important;
  text-decoration: none !important;
}

::v-deep .export-item:hover {
  background: rgba(0,0,0,0.04) !important;
}
.export-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none !important;
  background: transparent !important;
  padding: 4px 8px !important;
}
.export-item span {
  font-size: 14px;
}
.export-icon-item {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.export-icon-item.pdf { color: #e63946; }
.export-icon-item.word { color: #4fa4ff; }
.export-icon-item.canva { border-radius: 4px; }
.export-item:hover {
  background: #f4f8ff !important;
  color: #4fa4ff !important;
  text-decoration: underline !important;
}
.btn-back{
	border:none;
	padding:0 .5rem;
}
.scroll-container {
  overflow-y: auto;
  height: calc(100vh - 80px); /* header height */
}
</style>
